document.addEventListener('DOMContentLoaded', function() {
    const processedForms = new WeakSet();

    // Funzione per inviare il consenso a Iubenda
    function sendConsentToIubenda(form, callback) {
        _iub.cons_instructions.push([
            "submit",
            {
                form: {
                    selector: form
                },
                consent: {
                    legal_notices: [
                        { identifier: "privacy_policy" },
                        { identifier: "cookie_policy" },
                        { identifier: "term" },
                    ],
                }
            },
            {
                success: function(response) {
                    console.log("✅ Consenso Iubenda registrato con successo:", response);
                    if (callback) callback();
                },
                error: function(response) {
                    console.error("❌ Errore nella registrazione del consenso Iubenda:", response);
                    alert("Si è verificato un errore durante la registrazione del consenso. Riprova.");
                },
            },
        ]);
    }

    // Funzione per validare email
    function validateEmail(emailInput) {
        if (!emailInput) return true;
        const emailValue = emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailValue || !emailRegex.test(emailValue)) {
            console.warn('Email non valida o mancante.');
            alert('Per favore, inserisci un indirizzo email valido.');
            return false;
        }
        return true;
    }

    // Funzione per gestire Klaviyo form
    function handleKlaviyoForm(form) {
        if (processedForms.has(form)) return;
        processedForms.add(form);

        console.log("🎹 Klaviyo form rilevato:", form.id || form.className);

        // Trova il button di submit
        const button = form.querySelector('button[type="button"], button[type="submit"]');
        
        if (!button) {
            console.warn("⚠️ Button non trovato nel form Klaviyo");
            return;
        }

        // Rimuovi eventuali listener precedenti clonando il button
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        // Aggiungi il nostro listener con massima priorità
        newButton.addEventListener('click', function(event) {
            console.log("🔘 Click intercettato sul button Klaviyo");

            // Controlla Iubenda
            if (typeof _iub === 'undefined' || typeof _iub.cons_instructions === 'undefined') {
                console.error("❌ Script Iubenda (_iub) non trovato.");
                return;
            }

            // Valida email
            const emailInput = form.querySelector('input[data-cons-subject="email"], input[type="email"]');
            if (!validateEmail(emailInput)) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                return false;
            }

            // Blocca l'evento per prevenire l'invio a Klaviyo
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            console.log("📤 Invio consenso a Iubenda...");

            sendConsentToIubenda(form, function() {
                console.log("✅ Consenso registrato, reset form");
                form.reset();
                
                // Opzionale: se vuoi comunque inviare a Klaviyo dopo il consenso
                // setTimeout(() => {
                //     newButton.click();
                // }, 500);
            });

            return false;
        }, true); // Capture phase per intercettare prima di Klaviyo
    }

    // Funzione per gestire form standard
    function handleStandardForm(form) {
        if (processedForms.has(form)) return;
        processedForms.add(form);

        console.log("📝 Form standard rilevato:", form.id || form.className);

        form.addEventListener('submit', function(event) {
            event.preventDefault();

            if (typeof _iub === 'undefined' || typeof _iub.cons_instructions === 'undefined') {
                console.error("❌ Script Iubenda (_iub) non trovato.");
                return;
            }

            if (!form.checkValidity()) {
                console.warn('⚠️ Form non valido');
                form.reportValidity();
                return;
            }

            console.log("📤 Invio consenso a Iubenda...");

            sendConsentToIubenda(form, function() {
                form.submit();
            });
        });
    }

    // Funzione principale per processare i form
    function processForm(form) {
        // Evita di processare più volte
        if (processedForms.has(form)) return;

        // Aspetta un breve momento per assicurarsi che tutte le classi siano state aggiunte
        setTimeout(() => {
            const isKlaviyoForm = form.classList.contains('klaviyo-form') || 
                                 form.querySelector('[class*="klaviyo"]') !== null;
            
            if (isKlaviyoForm) {
                handleKlaviyoForm(form);
            } else {
                handleStandardForm(form);
            }
        }, 100);
    }

    // Processa form esistenti
    function scanForForms() {
        document.querySelectorAll('.form-iub').forEach(processForm);
    }

    // Scansione iniziale
    scanForForms();

    // Observer per nuovi form (più aggressivo)
    const observer = new MutationObserver(function(mutations) {
        let shouldScan = false;

        mutations.forEach(function(mutation) {
            // Controlla se sono stati aggiunti nodi
            if (mutation.addedNodes.length > 0) {
                shouldScan = true;
            }
            
            // Controlla anche se sono cambiate le classi
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                if (target.classList && target.classList.contains('form-iub')) {
                    processForm(target);
                }
            }
        });

        if (shouldScan) {
            scanForForms();
        }
    });

    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });

    // Scansione periodica come fallback (si ferma dopo 10 secondi)
    let scanCount = 0;
    const periodicScan = setInterval(() => {
        scanForForms();
        scanCount++;
        if (scanCount >= 20) { // 20 * 500ms = 10 secondi
            clearInterval(periodicScan);
            console.log("⏱️ Scansione periodica completata");
        }
    }, 500);

    console.log("🚀 Script Iubenda-Klaviyo inizializzato");
});